export default "__VITE_ASSET__C$a23ao3__"